import { createSignal } from 'solid-js'

import { dispatchAppAction } from '../runtimeBridge'
import { DEFAULT_UNIT_SYSTEM, normalizeUnitSystem, type UnitSystem } from '../utils/units'

const [unitSystem, setUnitSystemSignal] = createSignal<UnitSystem>(DEFAULT_UNIT_SYSTEM)

/**
 * Applies the unit-system preference pushed from the legacy app layer.
 *
 * @param value - The raw preference value.
 */
export function applyUnitSystemFromLegacy(value: unknown) {
   setUnitSystemSignal(normalizeUnitSystem(value))
}

/**
 * Selects a unit system from the UI; the legacy layer persists and syncs it
 * before pushing the normalized value back.
 *
 * @param value - The unit system to select.
 */
export function selectUnitSystem(value: UnitSystem) {
   const next = normalizeUnitSystem(value)
   setUnitSystemSignal(next)
   dispatchAppAction({ action: 'select-unit-system', unitSystem: next })
}

export { unitSystem }
